import { History } from 'history'

import { history } from 'Shared/utils/routing'

export default class HistoryStore {
	history: History

	constructor() {
		this.history = history
	}

	getPreviousPath = (): string => {
		const pathname = this.history.location.pathname
		return pathname.substring(0, pathname.lastIndexOf('/'))
	}
}
